import Injection = EECore.Injection;
import AdsService from "../../services/ads/adsService";
import AdsSlideshowEntity from "../../services/entities/ads/adsSlideshow";
import AdsEntity from "../../services/entities/ads/ads";
import Model from "../models/ads/adsSlideshowModel";
import AdsSlide from "./adsSlide";
import AdsSlideshowBehavior from "../../behaviors/ads/adsSlideshowBehavior";


@Injection.injectableClass("AdsSlideshow")
export default class AdsSlideshow implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("AdsSlideshow", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("AdsSlideshow", "AdsService")
  private adsService: AdsService;

  @Injection.injectableProperty("AdsSlideshow", EECore.Registrations.WEBCOMPONENT_FACTORY)
  private webComponentFactory: EECore.UI.WebComponentFactory;

  @Injection.injectableProperty("AdsSlideshow", EECore.Registrations.DOCUMENT)
  private document: Document;

  @Injection.injectableProperty("AdsSlideshow", EECore.Registrations.HTML_HELPER)
  private htmlHelper: EECore.HtmlHelper;

  @Injection.injectableProperty("AdsSlideshow", "AdsSlideshowBehavior")
  private adsSlideshowBehavior: AdsSlideshowBehavior;

  @Injection.injectableProperty("AdsSlideshow", EECore.Registrations.UNAVAILABLE_SERVICE)
  private unavailableService: EECore.Services.UnavailableService;

  constructor(templateFactory: EECore.UI.TemplateFactory,
    adsService: AdsService,
    webComponentFactory: EECore.UI.WebComponentFactory,
    document: Document, htmlHelper: EECore.HtmlHelper,
    adsSlideshowBehavior: AdsSlideshowBehavior,
    unavailableService: EECore.Services.UnavailableService) {
    this.templateFactory = templateFactory;
    this.adsService = adsService;
    this.webComponentFactory = webComponentFactory;
    this.document = document;
    this.htmlHelper = htmlHelper;
    this.adsSlideshowBehavior = adsSlideshowBehavior;
    this.unavailableService = unavailableService;
  }

  load(container: Element): EECore.Promise<Element, string> {
    const contentPath = container.getAttribute("ee-content-path");
    return new EECore.Promise<Element, string>((resolve, reject) => {
      this.adsService.getSlideshow(contentPath).then((adsSlideshowEntity: AdsSlideshowEntity) => {
        this.unavailableService.getAvailabilityservice("EXT2_PUBS").then((availability: EECore.Services.Entities.UnavailableModel) => {
          if (availability.isAvailable === false) {
            resolve(this.document.createDocumentFragment() as any);
          }
          else if (adsSlideshowEntity.ads.length === 0) {
            resolve(this.document.createDocumentFragment() as any);
          } else {
            const template = this.renderTemplate(adsSlideshowEntity);
            const slideContainer = template.querySelector(".slides") as HTMLElement;
            slideContainer.appendChild(this.renderSlides(adsSlideshowEntity.ads));
            if (adsSlideshowEntity.isResponsive && adsSlideshowEntity.ads.length > 0) slideContainer.appendChild(this.renderHiddenSlide(adsSlideshowEntity.ads[0]));

            const progressContainer = template.querySelector(".progress") as HTMLElement;
            progressContainer.appendChild(this.renderSlidesNavigation(adsSlideshowEntity.ads.length));

            this.adsSlideshowBehavior.apply(template, adsSlideshowEntity);
            resolve(template);
          }
        });
      }).catch(() => {
        reject("Could not get ads slideshow information.");
      });
    });
  }

  private renderTemplate(adsSlideshowEntity: AdsSlideshowEntity): Element {
    const model = new Model();
    model.cssClasses = adsSlideshowEntity.effect.toLowerCase();

    if (!adsSlideshowEntity.showOnDesktop) {
      model.cssClasses += " HideInFull";
      if (adsSlideshowEntity.showOnMobile) model.cssClasses += " ShowInMobile";
      if (adsSlideshowEntity.showOnTablet) model.cssClasses += " ShowInTablet";
    }

    if (!adsSlideshowEntity.showOnMobile) model.cssClasses += " HideInMobile";
    if (!adsSlideshowEntity.showOnTablet) model.cssClasses += " HideInTablet";

    if (adsSlideshowEntity.isResponsive) model.cssClasses += " responsive";
    model.controlsCssClasses = adsSlideshowEntity.controlsPosition.toLowerCase();
    if (!adsSlideshowEntity.showNavigation) model.controlsCssClasses += " hideNavigation";
    if (!adsSlideshowEntity.showPlayPause) model.controlsCssClasses += " hidePlayPause";
    model.progressCssClasses = adsSlideshowEntity.controlsPosition.toLowerCase();
    if (!adsSlideshowEntity.showPagination) model.progressCssClasses += " hideProgress";
    model.style = "";
    if (!adsSlideshowEntity.isResponsive) model.style = `style="width: ${adsSlideshowEntity.width}px; height: ${adsSlideshowEntity.height}px;"`;

    return this.templateFactory.getTemplate("AdsSlideshow", model);
  }

  private renderSlides(ads: AdsEntity[]): Element {
    const documentFragment = this.document.createDocumentFragment() as any;
    for (let i = 0; i < ads.length; i++) {
      const slide = this.renderSlide(ads[i]);
      const trackedSlide = this.adsService.trackAllLinks(slide);
      documentFragment.appendChild(trackedSlide);
    }
    return documentFragment;
  }

  private renderHiddenSlide(ads: AdsEntity): Element {
    const hiddenSlide = this.renderSlide(ads);
    this.htmlHelper.removeCssClass(hiddenSlide, "slide");
    this.htmlHelper.addCssClass(hiddenSlide, "hiddenSlide");

    return hiddenSlide;
  }

  private renderSlide(ads: AdsEntity): Element {
    const slide = this.webComponentFactory.getWebComponent(AdsSlide) as AdsSlide;
    slide.model = ads
    return slide.load();
  }

  private renderSlidesNavigation(adsCount: number): Element {
    const documentFragment = this.document.createDocumentFragment() as any;
    for (let i = 0; i < adsCount; i++) {
      documentFragment.appendChild(this.htmlHelper.fromString(`<span data-index="${i}"></span>`));
    }

    return documentFragment;
  }
}